export const makeURL = (docId: string) => {
  return `https://www.theboyfairy.com/@/${docId}`;
};
